export default __webpack_public_path__ + "static/media/Gauntlets of Heroic Soul.abd79c4f.jpg";